import { Attributes, DataSources } from '@leverege/ui-attributes';
import turfCenter from '@turf/center';
import turfCenterOfMass from '@turf/center-of-mass';
import { GroupDelegate, Relationship } from '@leverege/molten-core';
const EMPTY = {};

/**
 * Returns { relationship, match } for the parent relationship used to set
 * the attribute.
 */
function getParentRelationship(objRef, attr) {
  if (!objRef || !objRef.ref) {
    return null;
  }
  const {
    type,
    ref,
    id
  } = objRef;
  const lookupRef = ref.replace(`/${id}`, '');
  const lookupType = type;
  const delegate = DataSources.getDelegate({
    ...objRef,
    ref: lookupRef,
    type: lookupType
  }) || EMPTY;
  const {
    relationship,
    match
  } = delegate;

  // Given the obj's location in the relationship tree, look up the
  // location to find the possible parents
  if (relationship) {
    const srcs = attr?.blueprint?.attribute?.metadata?.setter?.parentSources;
    if (srcs) {
      const src = srcs.find(d => d.path === relationship.path);
      if (src && src.sourcePath) {
        const rel = Relationship.getByPath(src.sourcePath);
        if (rel) {
          return {
            relationship: rel.createResolved(match),
            match,
            filter: src.filter,
            queryName: `parentRel-${src.sourcePath}`,
            objectType: rel.options.objectType
          };
        }
      }
    }
  }
  return null;
}
function getParentCopyValues(attr) {
  return attr?.blueprint?.attribute?.metadata?.setter?.copyValues;
}
function getParentAction(objRef, attr) {
  const rel = getParentRelationship(objRef, attr);
  return rel ? new GroupDelegate({
    ...rel,
    ttl: 300000
  }) : null;
}

/**
 * Return null if no exra set events should be generated, or
 * an array of event object so be fired to the setter controller
 * @param {ObjRef} parentRef the Object Reference to the parent
 * @param {Attribute} attr the parentRelationship attribute we are setting
 * @param {Object} cxt the context
 */
function makeCopyEvents(parentRef, attr, cxt) {
  const copy = getParentCopyValues(attr);
  if (copy == null || parentRef == null) {
    return null;
  }
  const pRef = DataSources.withData(parentRef);
  if (pRef == null) {
    return null;
  }
  const rtn = copy.map(cp => {
    const {
      type,
      parent,
      child,
      copyNull
    } = cp;
    if (parent == null || child == null) {
      return null;
    }
    const pVal = Attributes.get(parent, pRef, cxt);
    if (pVal == null && !copyNull) {
      return null;
    }
    if (type === 'geoShapeCenterOfMass' || type === 'geoShapeCenter') {
      try {
        let geo = pVal;
        if (typeof geo === 'string') {
          geo = JSON.parse(geo);
        } else if (typeof geo !== 'object') {
          return null;
        }
        const center = type === 'geoShapeCenterOfMass' ? turfCenterOfMass(geo) : turfCenter(geo);
        const arr = center?.geometry?.coordinates;
        if (Array.isArray(arr)) {
          return {
            value: {
              lat: arr[1],
              lon: arr[0]
            },
            data: child
          };
        }
        return null;
      } catch (ex) {
        // eslint-disable-next-line no-console
        console.error(ex);
        return null;
      }
    } else {
      return {
        value: pVal,
        data: child
      };
    }
  }).filter(cp => cp != null);
  return rtn.length === 0 ? null : rtn;
}
export default {
  makeCopyEvents,
  getParentCopyValues,
  getParentAction,
  getParentRelationship
};